export const SHARING_TYPE = {
    DELIVERY: 'delivery',
};

export const PATHS = {
    ROOT: '#!',
    HOMEPAGE: '/',
    GIG_PAGE: 'gig_page',
    SELLER_PAGE: 'seller_page',
    SUB_CATEGORY_PAGE: 'short_category_sub_category',
};

export const ASSET_RESOURCE_TYPE = {
    ATTACHMENT: 'attachment',
};

export const AUDIO_ASSET_DEFAULT_PREVIEW_URL =
    'https://fiverr-res.cloudinary.com/q_auto,f_auto,dpr_2.0/general_assets/gig_gallery_package/assets/audio-delivery-bg.png';
